import { useQuery, useMutation } from "@tanstack/react-query";
import api from "../axios-client";
import { queryClient } from "../query-client";

export const useGetDeviceSettings = (deviceId: string) =>
    useQuery({
        queryKey: ["devices", deviceId, "settings"],
        queryFn: async () => {
            const response = await api.get(`/api/v1/devices/${deviceId}/settings`);
            return response.data.data;
        },
        retry: false,
        staleTime: 1000 * 60 * 60,
        enabled: !!deviceId,
    });

export const useUpdateDeviceSettings = () =>
    useMutation({
        mutationFn: async ({ deviceId, data }: { deviceId: string; data: any }) => {
            const response = await api.put(`/api/v1/devices/${deviceId}/settings`, data);
            return response.data.data;
        },
        onSuccess: (_, { deviceId }) => {
            queryClient.refetchQueries({ queryKey: ["devices", deviceId, "settings"] });
        },
    });

export const useClearDeviceSetting = () =>
    useMutation({
        mutationFn: async ({ deviceId, templateId }: { deviceId: string; templateId: string }) => {
            const response = await api.delete(`/api/v1/devices/${deviceId}/settings/${templateId}`);
            return response.data.data;
        },
        onSuccess: (_, { deviceId }) => {
            queryClient.refetchQueries({ queryKey: ["devices", deviceId, "settings"] });
        },
    });
